// sites.$siteId.prevention-plan.tsx — T080
// Route : /sites/:siteId/prevention-plan — plan de prévention (lecture HseAdmin/Reader).
// Guard : HseAdmin du site ou SystemAdmin.

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";

import { useAuth } from "@/application/contexts/AuthContext";
import type { MeasureDisplayStatus } from "@/domain/enums/measure-status";
import { PreventionPlanPage } from "@/presentation/pages/PreventionPlanPage";

import { Route as SiteRoute } from "./sites.$siteId";

const preventionPlanSearchSchema = z.object({
  status: z.enum(["ToBePlanned", "InProgress", "Overdue"]).optional(),
});

interface PreventionPlanSearch {
  status?: MeasureDisplayStatus;
}

export const Route = createFileRoute("/sites/$siteId/prevention-plan")({
  component: function PreventionPlanComponent() {
    const { siteId } = Route.useParams();
    const { status } = Route.useSearch();
    const { site } = SiteRoute.useLoaderData();
    const { canAccessSite, isLoading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (!isLoading && !canAccessSite(siteId, site.regionId)) {
        void navigate({ to: "/sites/$siteId", params: { siteId } });
      }
    }, [isLoading, canAccessSite, site.regionId, siteId, navigate]);

    return <PreventionPlanPage siteId={siteId} initialStatus={status} />;
  },
  validateSearch: (search: Record<string, unknown>): PreventionPlanSearch => {
    const parsed = preventionPlanSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
});
